module.exports = __webpack_public_path__ + "img/empty.252cd0b7.png";